import { render, staticRenderFns } from "./schedule.vue?vue&type=template&id=396dc2a0&scoped=true&"
import script from "./schedule.vue?vue&type=script&lang=js&"
export * from "./schedule.vue?vue&type=script&lang=js&"
import style0 from "./schedule.vue?vue&type=style&index=0&id=396dc2a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396dc2a0",
  null
  
)

export default component.exports